module.exports = __webpack_public_path__ + "img/w_fscl.bfe9ffba.png";